import type { SVGProps } from "react";

export const BankIcon = ({ props }: { props?: SVGProps<SVGSVGElement> }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      d="M1.5 6.4268C1.5 5.52967 1.86178 4.97987 2.61047 4.56321L5.6924 2.84808C7.30732 1.94936 8.11478 1.5 9 1.5C9.88522 1.5 10.6927 1.94936 12.3076 2.84808L15.3895 4.56321C16.1382 4.97987 16.5 5.52967 16.5 6.4268C16.5 6.67007 16.5 6.79171 16.4734 6.89171C16.3339 7.41709 15.8578 7.5 15.398 7.5H2.60196C2.1422 7.5 1.66614 7.41708 1.52656 6.89171C1.5 6.79171 1.5 6.67007 1.5 6.4268Z"
      stroke="#1453F5"
      strokeWidth="1.125"
    />
    <path
      d="M8.99707 5.25H9.00382"
      stroke="#1453F5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3 7.5V13.875M6 7.5V13.875" stroke="#1453F5" strokeWidth="1.125" />
    <path
      d="M12 7.5V13.875M15 7.5V13.875"
      stroke="#1453F5"
      strokeWidth="1.125"
    />
    <path
      d="M14.25 13.875H3.75C2.50736 13.875 1.5 14.8823 1.5 16.125C1.5 16.3321 1.66789 16.5 1.875 16.5H16.125C16.3321 16.5 16.5 16.3321 16.5 16.125C16.5 14.8823 15.4927 13.875 14.25 13.875Z"
      stroke="#1453F5"
      strokeWidth="1.125"
    />
  </svg>
);
